<template>
  <div v-if="$vuetify.breakpoint.smAndDown">
    <v-row>
      <!-- Provider -->
      <v-col
        class="d-flex flex-column justify-center align-center
        table-right-border table-right-border-light pa-2
        result-columns-align-width"
        @click="onClickViewDetails"
      >
        <img
          :src="details.imageSiteRemote"
          :alt="details.brokerFullName"
          class="provider-logo"
        >
        <results-price
          v-if="isViewMonthly"
          :quote="quote"
          :monthly="!isViewMonthly"
          :selected-optional-extras="[]"
          size="small"
          class="info--text pt-2"
        />
      </v-col>

      <!-- Price -->
      <v-col
        class="d-flex flex-column justify-center align-center
        table-right-border table-right-border-light pa-2
        result-columns-align-width"
        @click="onClickViewDetails"
      >
        <results-price
          :quote="quote"
          :monthly="isViewMonthly"
          :cashback="cashback"
          :selected-optional-extras="[]"
          @open-drawer-details="$emit('open-drawer-details', ['details-description', 'estimatedPrice'])"
        />
      </v-col>

      <!-- Policy details -->
      <v-col
        class="d-flex flex-column justify-center align-center text-center pa-2
                        result-columns-align-width"
      >
        <v-btn
          rounded
          :small="isViewMonthly"
          color="success"
          @click="onClickViewDetails"
        >
          <span>More</span>
        </v-btn>
      </v-col>
    </v-row>

    <div v-if="coveredOptionalExtras.length">
      <v-divider class="mt-3" />

      <ul class="d-flex flex-wrap pl-0">
        <li
          v-for="(extra, index) in coveredOptionalExtras"
          :key="index"
          class="col-6"
        >
          <v-icon
            :color="extra.icon === 'mdi-close' ? 'navy-dark' : 'primary'"
            class="mr-1"
          >
            {{ extra.icon }}
          </v-icon>
          {{ extra.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ResultsPrice from '@/components/car/Results/ResultsPrice.vue';

export default {
  name: 'quote-mobile',
  components: {
    ResultsPrice,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    details: {
      type: Object,
      required: true,
    },
    coveredOptionalExtras: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    cashback () {
      return +this.details.cashback;
    },
  },
  methods: {
    onClickViewDetails () {
      this.$emit('click-policy-details');
    },
  },
};
</script>

<style scoped lang="scss">
.provider-logo {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>
